import CanalLeafletMap from "@/components/CanalLeafletMap";

export default function ParcoursMap() {
  return (
    <section className="relative py-32 md:py-40 px-6 md:px-12" data-testid="parcours-map">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-14">
          <div className="md:col-span-6">
            <div className="meta-label text-cinabre">§ Le tracé · 750 km</div>
            <h2 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight mt-6">
              De l'Atlantique<br/>à la <em className="italic">Méditerranée</em>.
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8 self-end">
            <p className="text-fg/75 leading-relaxed text-lg">
              Une ligne artistique continue de Castets-en-Dorthe à l'Étang de Thau — le long du Canal latéral à la Garonne et du Canal du Midi. Cliquez sur les points pour explorer les six sites d'exposition 2026.
            </p>
          </div>
        </div>

        <CanalLeafletMap height="640px" />

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-14">
          {[
            ["Canal latéral à la Garonne", "Castets → Toulouse · 193 km"],
            ["Canal du Midi", "Toulouse → Sète · 240 km"],
            ["Écluses & ouvrages", "63 écluses"],
            ["Voie cyclable", "V80 continue"],
          ].map(([k, v]) => (
            <div key={k} className="border-t border-fg/20 pt-4">
              <div className="font-serif text-2xl leading-tight">{k}</div>
              <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-fg/60 mt-1">{v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
